module.exports = __webpack_public_path__ + "static/media/instagram.12ea2b21.svg";